import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import {Button, FormControl, TextField} from "@mui/material";


export default function Contact() {

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = new FormData(e.target);
    let formObject = Object.fromEntries(data.entries());
    alert(JSON.stringify(formObject));
  }


  return (

    <Container>
      <h1 className="">Contact iStore</h1>

      <Row>

        <Col xs={12} sm={6} className="text-right">

          <div className="mb-2 border rounded p-4 h-100">

            <div className="">
              <h3 className="" itemProp="headline">Head Office</h3>
            </div>
            <div className="mb-5">
              <p>
                iStore - Air to Energy<br/>
                <i>A revolution in energy storage</i><br/><br/>
                ABN: 54 152 166 160<br/>
                U4 242 Beringarra Ave<br/>
                Malaga Western Australia 6090<br/>
              </p>
            </div>

            <div className="mb-4">
              <h3 className="" itemProp="headline">Contact iStore by Email</h3>
              <p className=""><a href="mailto:info@istore.net.au">info@istore.net.au</a></p>
            </div>

            <div className="mb-2">
              <h3 className="" itemProp="headline">Contact iStore by Phone</h3>
              <p className=""><a title="Call iStore on 1300 552 619" href="tel:1300515636"><span>1300 515 636</span></a>
              </p>
            </div>

          </div>
        </Col>

        <Col xs={12} sm={6}>

          <div className="mb-2 p-4 h-100">

            <p className="text-black-50">Leave you details with us and we'll get right back.</p>

            <form onSubmit={handleSubmit}>

              <FormControl fullWidth className="my-2">
                <TextField name="firstname" placeholder="First Name"/>
              </FormControl>

              <FormControl fullWidth className="my-2">
                <TextField name="lastname" placeholder="Last Name"/>
              </FormControl>

              <FormControl fullWidth className="my-2">
                <TextField name="email" placeholder="Email"/>
              </FormControl>

              <FormControl fullWidth className="my-2">
                <TextField name="phone" placeholder="Phone number"/>
              </FormControl>

              <FormControl fullWidth className="my-2">
                <TextField multiline rows="4" name="message" placeholder="Message"/>
              </FormControl>

              <Button size="large" variant="contained" type="submit">Submit Contact</Button>
            </form>
          </div>
        </Col>


      </Row>
    </Container>
  );
}

